<template>
  <Container background-color="#F5F7FA" :bounds-inner-styles="containerStyles">
    <h2 class="scout-ways-title">Two ways to build with <b style="color:#4440db;">Scout</b></h2>
    <div class="scout-ways-description">
      Every company is unique, and hiring processes even more so.
      <span style="color:#4440db; font-weight: bold;">Scout</span> adapts to your needs—whether you
      require full deployment or just an extra pair of hands.
    </div>
    <img class="scout-ways-pattern" src="@/assets/pages/scout/middle_grey_pattern.svg" />
    <b-row class="scout-ways-items">
      <div v-for="way in ways" :key="way.id" class="scout-ways-way">
        <div class="scout-ways-way_body">
          <div class="scout-ways-way_header">{{ way.id }}</div>
          <div class="scout-ways-way_title" v-html="way.title"></div>
          <div class="scout-ways-way_description" v-html="way.description"></div>
          <div
            v-if="areThereAnyPlans > 0"
            class="scout-ways-way_cost"
            v-html="parseRealCost({ template: way.cost, planName: way.name })"
          ></div>
          <div class="scout-ways-way_details">
            <div v-for="detail in way.details" :key="detail.id" class="scout-ways-detail">
              <div class="scout-ways-detail_title">{{ detail.title }}:</div>
              <div class="scout-ways-detail_content" v-html="detail.content"></div>
            </div>
          </div>
          <div class="scout-ways-way_candidates">
            <div
              v-for="candidate in way.candidates"
              :key="candidate.id"
              class="scout-ways-candidate"
            >
              <img class="scout-ways-candidate_avatar" :src="candidate.img" />
            </div>
          </div>
          <button class="scout-ways-btn" @click="handlePostJobClick(way.name)">
            {{ way.postJobBtnTitle }}
          </button>
        </div>
      </div>
    </b-row>
  </Container>
</template>

<script>
import Container from '@/components/Container';

export default {
  name: 'ScoutWays',
  components: {
    Container
  },
  props: {
    rawPlans: {
      type: Object,
      default: {}
    },
    getStarted: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      ways: [
        {
          id: '01',
          name: 'Headhunter',
          title: `
              <div style='display:flex; align-items:center'>
              <span style="color:#4440db">Scout</span> 
              <div style="
                background-color:#f81f41;
                color:white;
                font-size: 14px;
                font-weight: bold;
                padding: 0.3rem 0.5rem 0.2rem 0.5rem;
                margin-left: 0.5rem;
                height: 1.5rem;
                display:flex;
                align-items: center;
                justify-content: center;
                ">
                NO CURE, NO PAY
              </div>
              </div>
            `,
          titleLink: '/scout',
          description: `<ul>
              <li>You have a clearly <b>defined hiring process</b></li>
              <li>Your goal is to <b>hire the right candidates quickly</b></li>
              <li>You <b>don’t have an internal Talent Acquisition team</b> or dedicated recruitment resources</li>
             </ul> 
            `,
          cost:
            '<span style="color:#4440db;">0</span> upfront, <span style="color:#4440db;">[currency]</span> per hire',
          details: [
            {
              id: 's_terms',
              title: 'Terms',
              content:
                '<a href="/scout-terms" target="_blank" style="color:#4440db">Scout terms of use</a>'
            },
            {
              id: 's_duration',
              title: 'Duration',
              content: 'Up to 12 weeks (until a hire is made)'
            }
            // {
            //   id: 's_recommended_for',
            //   title: 'Recommended for',
            //   content: 'Mid/Senior & C-Level roles'
            // }
          ],
          candidates: [
            // { id: 's_c_0', img: require('@/assets/pages/scout/orange_candidate.webp') },
            // { id: 's_c_1', img: require('@/assets/pages/scout/white_candidate.webp') },
            // { id: 's_c_2', img: require('@/assets/pages/scout/green_candidate.webp') },
            // { id: 's_c_3', img: require('@/assets/pages/scout/blue_candidate.webp') },
            // { id: 's_c_4', img: require('@/assets/pages/scout/beige_candidate.webp') }
          ],
          postJobBtnTitle: 'Get started for free',
          postJobUrl: '/scout'
        },
        {
          id: '02',
          name: 'Max',
          title:
            '<span style="color:#4440db">Max</span> <span style="font-size:20px; font-weight: bold">(Scout Lite)</span>',
          // description:
          //   'You have one or more key roles to fill, a <b>defined hiring process</b> with internal stakeholders, and a <b>clear timeline</b>. You’re ready to tap into The Hub’s top talent, prioritize the process, and <b>hire the right candidates quickly</b>.',
          description: `<ul>
              <li>Your <b>hiring process is “floating”</b> and less defined</li>
              <li>Your goal is to <b>extend and grow your talent pool</b> and the time-to-hire is less critical</li>
             </ul> 
          `,
          // cost: '[currency] upfront',
          cost:
            '<span style="color:#4440db;">[currency]</span> upfront, <span style="color:#4440db;">0</span> per hire',
          details: [
            {
              id: 'm_terms',
              title: 'Terms',
              content: 'No terms'
            },
            {
              id: 'm_duration',
              title: 'Duration',
              content: 'Up to 4 weeks'
            }
            // {
            //   id: 'm_recommended_for',
            //   title: 'Recommended for',
            //   content: 'Junior,  Mid & Senior roles'
            // }
          ],
          candidates: [
            // { id: 'm_c_0', img: require('@/assets/pages/scout/orange_candidate.webp') },
            // { id: 'm_c_1', img: require('@/assets/pages/scout/green_candidate.webp') },
            // { id: 'm_c_2', img: require('@/assets/pages/scout/blue_candidate.webp') }
          ],
          postJobBtnTitle: 'Post max job post',
          postJobUrl: '/scout'
        }
      ]
    };
  },
  methods: {
    handlePostJobClick(name) {
      // alert(`handlePostJobClick ${name}`);
      this.getStarted(name);
    },
    parseRealCost({ template, planName }) {
      if (!template || !planName) return '';
      return template?.replace('[currency]', this.plans[planName?.toUpperCase()]?.cost);
    }
  },
  computed: {
    plans() {
      return this.rawPlans || {};
    },
    areThereAnyPlans() {
      return Object.keys(this.plans).length;
    },
    containerStyles() {
      return {
        'padding-top': `${2}rem`,
        'padding-bottom': `${4.5}rem`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.scout {
  a {
    color: #4440db;
  }
}

.scout-ways-pattern {
  position: absolute;
  // top: 10px;
  right: -5.3rem;
  margin-top: -4.5rem;
  z-index: 1;
  @include media-breakpoint-down(sm) {
    display: none;
  }
}

.scout-ways-title {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  width: 70%;
  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

.scout-ways-description {
  font-size: rem(18px);
  margin-bottom: 3rem;
  width: 50%;
  text-align: justify;
  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

.scout-ways-items {
  z-index: 2;
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 2rem;
  grid-row-gap: 3rem;
  @include media-breakpoint-down(md) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(1, 1fr);
  }
  margin: 0px;
}

.scout-ways-way {
  background-color: white;
  width: 100%;
  padding: 0.8rem;
  margin-right: 1.5rem;
}

.scout-ways-way_img {
  width: 100%;
  margin-bottom: 1.5rem;
}

.scout-ways-way_header {
  font-size: rem(52px);
  font-weight: 600;
  background-color: #f5f7fa;
  height: 5rem;
  width: 5rem;
  margin-bottom: 1rem;
  padding-left: 2rem;
  padding-top: 0.4rem;
}

.scout-ways-way_body {
  padding: 1.5rem 1.5rem 3rem 1.5rem;
}

.scout-ways-way_title {
  font-size: rem(32px);
  font-weight: 500;
  margin-bottom: 1rem;
  line-height: 1.3;
}

.scout-ways-way_description {
  margin-bottom: 2rem;
  font-size: 1rem;
  margin-left: -1rem;
  min-height: rem(115px);
}

.scout-ways-way_cost {
  // color: #4440db;
  // font-size: 1.3rem;
  font-size: rem(18px);
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.scout-ways-way_details {
  margin-bottom: 1rem;
}

.scout-ways-detail {
  // font-size: 0.9rem;
  font-size: rem(14px);
  margin-bottom: 0.5rem;
  display: flex;
}

.scout-ways-detail_title {
  color: #818975;
}

.scout-ways-detail_content {
  margin-left: 1rem;
  font-weight: 500;
}

.scout-ways-way_candidates {
  display: flex;
  margin-bottom: 2rem;
  margin-left: 25px;
}

.scout-ways-candidate {
  font-size: 0.9rem;
  padding: 0.2rem 0.5rem;
  color: #4440db;
  margin-left: -30px;
}

.scout-ways-candidate_avatar {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  outline: 1px solid #4440db;
  border: 1px solid white;
  outline-offset: -2px;
  object-fit: cover;
}

.scout-ways-buttons {
  margin: 2rem 0 0 0;
}

.scout-ways-btn {
}

.scout-ways-way_wrapper {
  display: block;
}

.scout-ways-point_logo {
  height: 45px;
}

.scout-ways-point_title {
  font-weight: bold;
  font-size: large;
  margin-top: 1.5rem;
}

.scout-ways-point_description {
  margin-top: 1rem;
  width: 80%;
}

.scout-ways-buttons {
  margin-top: 3rem;
}

.scout-ways-btn {
  background-color: #4440db;
  color: white;
  height: 4rem;
  width: 17.625rem;
  font-weight: bold;
}
</style>
